export const Screens = {
  Home: 'Home',
  Rebook: 'Rebook',
  Flight: 'Flight',
  FlightCloud: 'Flights',
  Hotel: 'Hotel',
  HotelDetail: 'HotelDetail',
  Car: 'Car',
  Rail: 'Rail',
  TripSummary: 'TripSummary',
  Passenger: 'Passenger',
  Seat: 'Seat',
  Purchase: 'Purchase',
  Receipt: 'Receipt',
  Me: 'Me',
  MyTrips: 'MyTrips',
  Contact: 'Contact',
  Terms: 'Terms',
  Settings: 'Settings',
  Privacy: 'Privacy',
  Notification: 'Notification',
  About: 'About',
  Legal: 'Legal',
  TermsOfUse: 'TermsOfUse',
  PrivacyPolicy: 'PrivacyPolicy',
  TripHub: 'TripHub',
  AirChange: 'AirChange',
  CarChange: 'CarChange',
  RailChange: 'RailChange',
  Rooms: 'Rooms',
  Alerts: 'Alerts',
  Social: 'Social',
  Expense: 'Expense',
  RebookHome: 'RebookHome',
  EventHome: 'EventHome',
  AAHome: 'AAHome',
  AASearchScreen: 'AASearchScreen',
  EasyCardScreen: 'EasyCardScreen',
  ExpenseCamera: 'ExpenseCamera',
  UserActivation: 'UserActivation',
};

export const Modals = {
  Login: 'Login',
  Rebook: 'Rebook',
  Calendar: 'Calendar',
  ChangeResModal: 'ChangeResModal',
  ChangeResWidget: 'ChangeResWidget',
  AirFilterModal: 'AirFilterModal',
  AirFilterModalCloud: 'AirFilterModalCloud',
  CarFilterModal: 'CarFilterModal',
  HotelFilterModal: 'HotelFilterModal',
  RailFilterModal: 'RailFilterModal',
  TripFilterModal: 'TripFilterModal',
  StationAutoCompleteModal: 'StationAutoCompleteModal',
  ResearchWidgetModal: 'ResearchWidgetModal',
  SearchTripOptionsModal: 'SearchTripOptionsModal',
  TripSummaryModal: 'TripSummaryModal',
  AgentContact: 'AgentContact',
  LanguageModal: 'LanguageModal',
  ProfileModal: 'ProfileModal',
  RebookModal: 'RebookModal',
  CreditCardModal: 'CreditCardModal',
  LoyaltyModal: 'LoyaltyModal',
  PassengerLoyaltyForm: 'PassengerLoyaltyForm',
  HotelLoyalty: 'HotelLoyalty',
  PassportModal: 'PassportModal',
  PasswordModal: 'PasswordModal',
  AirSeatModal: 'AirSeatModal',
  RailSeatModal: 'RailSeatModal',
  RideShareModal: 'RideShareModal',
  DirectionModal: 'DirectionModal',
  MeetingModal: 'MeetingModal',
  MeetingFormModal: 'MeetingFormModal',
  ActivitiesWebModal: 'ActivitiesWebModal',
  CheckInWebModal: 'CheckInWebModal',
  InvitationModal: 'InvitationModal',
  TrackTrainWebModal: 'TrackTrainWebModal',
  InviteTravelerModal: 'InviteTravelerModal',
  EmailItineraryModal: 'EmailItineraryModal',
  TripExpenseModal: 'TripExpenseModal',
  TripExpenseAddModal: 'TripExpenseAddModal',
  CategorySelectorModal: 'CategorySelectorModal',
  AttendeesSelectorModal: 'AttendeesSelectorModal',
  TravelSettingsModal: 'TravelSettingsModal',
  EventSettingsModal: 'EventSettingsModal',
  EventPreviewModal: 'EventPreviewModal',
  EventEditModal: 'EventEditModal',
  TimePickerModal: 'TimePickerModal',
  InvitationTravelerModal: 'InvitationTravelerModal',
  SelectorModal: 'SelectorModal',
  InvitePermissionsModal: 'InvitePermissionsModal',
  TravelerSafetyModal: 'TravelerSafetyModal',
  AALoginScreen: 'AALoginScreen',
  AACalendarModal: 'AACalendarModal',
  OneWayBXAlertModal: 'OneWayBXAlertModal',
  MessagesModal: 'Messages',
  HomepageOnewayModal: 'HomepageOnewayModal',
  AddReviewModal: 'AddReviewModal',
  ReceiptScannerModal: 'ReceiptScannerModal',
  CreateExpenseModal: 'CreateExpenseModal',
  ReceiptVaultModal: 'ReceiptVaultModal',
  ViewReceiptModal: 'ViewReceiptModal',
  ExpenseReportCardModal: 'ExpenseReportCardModal',
  ExpenseFormStepTwo: 'ExpenseFormStepTwo',
  ExpenseParticipantModal: 'ExpenseParticipantModal',
  PaymentModal: 'PaymentModal',
};

export const Stacks = {
  MainStack: 'MainStack',
  AAHomeStack: 'AAHomeStack',
  HomeStack: 'HomeStack',
  MytripsStack: 'MyTripsStack',
  AlertStack: 'AlertStack',
  SocialStack: 'SocialStack',
  MeStack: 'MeStack',
  SettingsStack: 'SettingsStack',
  ContactStack: 'ContactStack',
  TermsStack: 'TermsStack',
  PrivacyStack: 'PrivacyStack',
  TabsStack: 'TabsStack',
  ExpenseStack: 'ExpenseStack',
  EventStack: 'EventStack',
};
